/* @flow */

import * as React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import uuidv4 from 'uuid/v4';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import { Roles } from 'permissions/defs';
import { customerUsers } from 'permissions/userTypes';

//----------------------------------------------------------------------//
// CSS                                                                  //
//----------------------------------------------------------------------//

import styles from './CurrentUserRole.module.scss';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

@translate()
@observer
export default class CurrentUserRole extends React.Component<*> {
  /*eslint-disable max-len*/

  userRoles = customerUsers.map(role => ({
    role: role,
    label: `general:roles.${role}`,
    description: `general:roles.descriptions.${role}`,
  }));

  render(): React.Element<*> {
    const t: Function = this.props.t;
    const user: Object = this.props.user;

    return (
      <React.Fragment>
        <h3>{t('general:roles.labels.current_user_role')}</h3>
        <List className={styles.userRoleList} disablePadding={true}>
          {this.userRoles.map(userRole => (
            <ListItem
              key={uuidv4()}
              className={`${styles.userRoleListItem} ${
                user.role_id === userRole.role ? styles.active : ''
              }`}
            >
              <ListItemIcon className={styles.userRoleListIcon}>
                <svg>
                  <use xlinkHref="#icon-profile" />
                </svg>
              </ListItemIcon>
              <ListItemText
                primary={t(`${userRole.label}`)}
                secondary={t(`${userRole.description}`)}
              />
            </ListItem>
          ))}
        </List>
      </React.Fragment>
    );
  }
}
